import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DesignSettings } from "@models/design-settings";

export interface InitialState {
  designSettings: DesignSettings | undefined;
}

const initialState: InitialState = {
  designSettings: undefined,
};

export const settings = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setDesignSettings: (state, action: PayloadAction<DesignSettings | undefined>) => {
      state.designSettings = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase("logout", () => initialState);
  },
});

export const { setDesignSettings } = settings.actions;

export default settings.reducer;
